import Vue from "vue";
import Router from "vue-router";
import Reservation from "@/page/Reservation";
import InvalidStore from "@/page/InvalidStore";
import Register from "@/page/Register";
import BookingView from "@/page/BookingView";
// import Success from "@/page/Success";
import Success2 from "@/page/Success2";
import Error from "@/page/Error";
import SelectCard from "@/page/Card/SelectCard";
import Opayo from "@/components/Opayo";
import Preview from "@/page/Preview/index.vue";
import { configTheme } from "@/utils/theme";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      //			path: '/reservation/:store_name/:success/:res_id',
      path: "/reservation/:store_name",
      name: "Reservation",
      component: Reservation
    },
    {
      path: "/",
      name: "InvalidStore",
      component: InvalidStore
    },
    {
      path: "/bookingView/:reserve_number",
      name: "BookingView",
      component: BookingView
    },
    {
      path: "*",
      name: "NotFound",
      component: InvalidStore
    },
    {
      path: "/register",
      name: "Register",
      component: Register
    },

    {
      path: "/success/:reserve_number",
      name: "Success",
      component: Success2
    },
    {
      path: "/error",
      name: "Error",
      component: Error
    },
    {
      path: "/selectcard",
      name: "SelectCard",
      component: SelectCard
    },
    {
      path: "/opayo",
      name: "Opayo",
      component: Opayo
    },
    {
      path: "/preview/:store_name",
      name: "Preview",
      component: Preview
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  // configTheme("#892e2a", "#bbb");

  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js